import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {AhoraCryptoCommonModule} from "@aparraga/ahoracrypto-client-common/src/app/common/ahoracrypto-common.module";
import {Landing1Component} from "./landing1/landing1.component";
import {CountUpModule} from "ngx-countup";
import {CryptoForm1Component} from "../shared/webflow/cryptoform1/cryptoform1.component";
import {LandingPagesRoutingModule} from "./landings-route.module";
import {PartsModule} from "../shared/parts/parts.module";
import {CryptoHero1Component} from "../shared/webflow/cryptohero1/cryptohero1.component";
import {CryptoForm2Component} from "../shared/webflow/cryptoform2/cryptoform2.component";

@NgModule({
  imports: [
    FormsModule,
    RouterModule,
    CommonModule,
    CountUpModule,
    ReactiveFormsModule,
    PartsModule,
    AhoraCryptoCommonModule,
    LandingPagesRoutingModule
  ],
  declarations: [
    Landing1Component,
    CryptoForm1Component,
    CryptoHero1Component,
    CryptoForm2Component
  ],
  exports: [
    Landing1Component,
    CryptoForm1Component,
    CryptoHero1Component,
    CryptoForm2Component
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})

export class LandingsModule {}

